export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/performance-1-on-1s-layered@2x.7b1fb2f4020dba37ef2b16c1c7efbcd8.png";